import React from 'react'
interface NameCellProps {
  name: string
  meta?: string
}

const NameCell = ({ name, meta }: NameCellProps) => {
  return (
    <div>
      <strong>{name}</strong> <br />
      {meta}
    </div>
  )
}

export default NameCell
